import Vue from "vue";

let config = Vue.observable({
  gtagId: "",
  scrileGtagId: "",
  locale: process.env.VUE_APP_LOCALE || "en-US",
  localeOverrides: {},
  creatorContractUrl: "",
  maxUploadSize: 10737418240,
  apiUrl: process.env.VUE_APP_API_URL || "/graphql",
  backendUrl: process.env.VUE_APP_BACKEND_URL || "/api",
  s3Url: process.env.VUE_APP_S3_URL || "/files",
  s3UploadUrl: process.env.VUE_APP_S3_UPLOAD_URL || "/files",
  publicS3Url: process.env.VUE_APP_PUBLIC_S3_URL || "/public-files",
  thumbnailUrl: process.env.VUE_APP_THUMBNAIL_URL || "/image-thumbnails",
  videoThumbnailUrl: process.env.VUE_APP_VIDEOTHUMBNAIL_URL || "/video-thumbnails",
  supportEmail: "",
  facebookAppId: "519046602188218",
  googleClientId: "",
  metaDescription: "",
  // TODO: default url should be production url.
  twitterCallbackUrl:
    process.env.VUE_APP_TWITTER_CALLBACK_URL ||
    (typeof window !== "undefined" &&
      `${window.location.protocol}//${window.location.hostname}${
        window.location.port ? ":" + window.location.port : ""
      }/login/twitter`) ||
    "",
  sentryKey: process.env.VUE_APP_SENTRY_DSN || "",
  fileTypes: {
    image: [
      "jpg",
      "jpeg",
      "jpe",
      "heif",
      "heic",
      "png",
      "webp",
      "jxr",
      "jif",
      "jfif",
      "jfi",
      "jp2",
      "j2k",
      "jpf",
      "jpx",
      "jpm",
    ],
    video: ["webm", "mkv", "mov", "qt", "wmv", "mp4", "m4v", "mpg", "mpeg", "mpv", "avi"],
    audio: ["mp3", "aac", "ogg", "m4a"],
    document: ["pdf"],
  },
  userRegistrationRole: "member",
  // number of days before delete members account; number of days
  restoreAccountInterval: 30,
  questionaryHiddenField: ["calendar"],
  companyName: "Academtech LLC",
  companyAddress: "690 S Highway 89, Suite 200, 83001, Jackson, Wyoming, USA",
  moneyUseGrouping: false,
  auth: {
    facebook: false,
    twitter: true,
    google: false,
  },
  attachments: {
    MAX_COVER_FILES: 1,
    MAX_FILES_UPLOAD_FOR_CREATOR: 5,
    MAX_FILES_UPLOAD_FOR_MEMBER: 1,
  },
  // if true enable all nsfw features: sensitive content popup, settings in menu, content filtration
  featureNSFW: false,
  // must match with value on backend
  maxAllowedPins: 3,
  // if true then allow signup by phone instead of email
  featurePhoneSignUp: false,
  // if true then allow go live
  featureGoLive: true,
  // if true then allow react on posts
  featureFeedReaction: true,
  // if true then allow view online users status
  featureUserOnlineStatus: true,
  // if true then allow paid message options on site
  featurePaidSentMessage: true,
  // if true then allow tipping in messages
  featureTippingMessages: true,
  // if true then allow tipping in the live chat
  featureTippingLive: true,
  // if true then allow tipping in posts
  featureTippingPosts: true,
  // if true then allow callings on site
  featureCalling: true,
  // if true then allow create new event type posts.
  featureEvents: true,
  // if true then allow send scheduled mass messages.
  featureScheduledMassMessage: true,
  // if true then restricts 'member' role: hides social network links, location and tags, its edit
  featureRestrictMember: false,
  // if true then users with 'member' role can create posts
  featureEveryoneCanPost: false,
  // if true, there are themes on the site
  featureTags: true,
  featureHashtags: true,
  // if has name of field, it will be required
  featurePayeeInfoRequiredFields: ["id_photo", "photo_with_id"],
  // Define allowed file types for posts, except those do not defined in fileTypes.
  postAllowedFileTypes: ["image", "video", "audio", "document"],
  // if true creator can use links to different resources
  featureClickableUserLinks: true,
  // if true and "featureClickableUserLinks" is enabled creator can use links to different external resources
  featureClickableUserExternalLinks: false,
  siteName: "connect",
  // if ture will enabled to use Refill Balance Button in Balance History
  get featureBalanceRefill() {
    return this.featureCalling || this.featurePaidSentMessage;
  },
  // if true, will add route to process login redirect from admin side with token
  featureLoginAsUser: true,
  // if true, will add route "followingSetting", add route subAndFollow, on welcomeMessage for subscriptionLevels
  featureWelcomeMessage: true,
  // if true, will enable recording audio messages
  featureAudioMessageAttachments: true,
  featureIuguPaymentSystem: false as boolean | "testMode",
  // if true, will hide user profiles from unauthorized users
  featurePrivateProfile: false,
  // if true, visitors can see Followers count in the profile page of users
  featurePublicFollowers: true,
  // if true, visitors can see Following count in the profile page of users
  featurePublicFollowing: true,
  // if true, a creator is able to request a payout
  featurePayoutRequest: true,
  // if true, a creator/agent is able to see their statements
  featureStatements: true,
  // if true, will show search user bar on Discover page
  featureSearchBar: true,
  // if true, will show creators tab on home page
  featureDiscoveryCreators: true,
  // if true, will show count creators corresponding tabs
  featureDiscoveryCreatorsCountInTabs: false,
  // if true, will show likes statistic on profile page
  featureProfileLikeStats: false,
  // if true, will show reviews in posts
  featureFeedPublicReview: true,
  // if true, user can downloads free files
  featureDownload: false,
  // if true, user can use dark theme for application
  featureDarkMode: false,
  // if true, hide powered by link
  featureHideScrileLink: true,
  webviewTargetOrigin: process.env.REACT_APP_WEBVIEW_TARGET_ORIGIN || "",
  delightVideoPlayerLicense: "",
  // if true, will show moreProfileHeader in more menu
  featureSwitchAccount: false,
  // if true, show announcements in home page for users
  featureAnnouncements: true,
  //if true, show message sort on message threads page
  featureSortMessages: true,
  webPushNotificationsPublicKey: "",
  // if true, all purchases except subscriptions and balance refill will be paid from balance
  featurePurchaseFromBalance: true,
  // if set to true, all subscriptions will be paid from the balance
  featureSubscribeFromBalance: true,
  // if true allow creator to pin post
  featurePinPost: true,
  // if true show list features for enabled/disabled
  featureFlagsDisplay: false,
  // if true show for creator modes visibility onlineStatus
  featureInvisibleMode: false,
  featureAppointments: false,
  featureOfflineAppointments: false,
  // if member can become creator
  featureSoloModel: false,
  // if true hide fields location & language
  featureHideLocalization: false,
  // if true allow to create stories
  featureStories: true,
  // if true allow to create posts with paid text
  featureTextPosts: false,
});

export function setConfig(override: Partial<typeof config>) {
  for (const key in override) {
    Vue.set(config, key, override[key as keyof typeof override]);
  }
}

export default config;
